import { Link } from "react-router-dom";
import { Scale, Phone, Mail, MapPin } from "lucide-react";
import { WHATSAPP_URL } from "../lib/api";

export default function Footer() {
  return (
    <footer className="bg-[#0A2540] text-slate-200 mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-5">
            <div className="relative w-12 h-12 flex-shrink-0 rounded-full bg-white/10 backdrop-blur-sm ring-1 ring-white/25 flex flex-col items-center justify-center">
              <Scale size={18} className="text-[#93C5FD] mb-0.5" strokeWidth={1.75} />
              <div className="h-px w-5 bg-[#93C5FD]/50"></div>
              <span className="font-serif text-[9px] text-[#93C5FD] tracking-[0.3em] font-semibold mt-0.5 leading-none">SM</span>
            </div>
            <div>
              <div className="font-serif text-lg text-white">Shubham Makkar</div>
              <div className="text-[10px] tracking-[0.25em] uppercase text-[#93C5FD]">
                Corporate Lawyer
              </div>
            </div>
          </div>
          <p className="text-sm text-slate-400 leading-relaxed max-w-xs">
            Chandigarh-based corporate lawyer. Practising before Punjab &amp; Haryana High Court
            and District Courts across Punjab, Haryana and Chandigarh.
          </p>
        </div>

        <div>
          <div className="text-[10px] uppercase tracking-[0.22em] font-semibold text-[#93C5FD] mb-4">Practice</div>
          <ul className="space-y-3 text-sm text-slate-300">
            <li><Link className="hover:text-white transition-colors" to="/services/corporate-lawyer">Corporate Defence</Link></li>
            <li><Link className="hover:text-white transition-colors" to="/services/bail-lawyer">Bail Applications</Link></li>
            <li><Link className="hover:text-white transition-colors" to="/services/anticipatory-bail">Anticipatory Bail</Link></li>
            <li><Link className="hover:text-white transition-colors" to="/cases">Case Experience</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-[10px] uppercase tracking-[0.22em] font-semibold text-[#93C5FD] mb-4">Firm</div>
          <ul className="space-y-3 text-sm text-slate-300">
            <li><Link className="hover:text-white transition-colors" to="/blog">Legal Insights</Link></li>
            <li><Link className="hover:text-white transition-colors" to="/book">Book Consultation</Link></li>
            <li><Link className="hover:text-white transition-colors" to="/admin/login">Admin</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-[10px] uppercase tracking-[0.22em] font-semibold text-[#93C5FD] mb-4">Reach Us</div>
          <ul className="space-y-3 text-sm text-slate-300">
            <li className="flex items-start gap-2">
              <MapPin size={16} className="text-[#93C5FD] mt-0.5 flex-shrink-0" />
              <span>UG-4, Green Lotus Saksham, Zirakpur, Mohali</span>
            </li>
            <li className="flex items-center gap-2">
              <Phone size={16} className="text-[#93C5FD]" />
              <a href={WHATSAPP_URL()} className="hover:text-white">+91 7719693033</a>
            </li>
            <li className="flex items-center gap-2">
              <Mail size={16} className="text-[#93C5FD]" />
              <a href="mailto:office@makkar.law" className="hover:text-white">advocate.shubhammakkar@gmail.com</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row justify-between text-xs text-slate-400">
          <div>© {new Date().getFullYear()} Advocate Shubham Makkar. All rights reserved.</div>
          <div className="mt-2 md:mt-0">Disclaimer: Information on this site does not constitute legal advice.</div>
        </div>
      </div>
    </footer>
  );
}
